import { filter } from 'rxjs/operators';

import type {
  ReportDashboardComponent,
  ReportDashboardComponentViewData,
} from '@core/reports-types';

export const filterByMetricKind = <T extends { component: ReportDashboardComponentViewData }>(
  kind: ReportDashboardComponent['kind'],
) => filter<T>(({ component }: T) => component.kind === kind);

export { applyAmountOfDataSettingPipe } from './apply-amount-of-data-setting-pipe';
export { stripValueMetadata } from './strip-value-metadata';
export { fromBlueprints } from './from-blueprints';
export { visualize } from './visualize';
export { normalizePipe } from './normalizePipe';
export { sanitize } from './sanitize';
export { createAxisTitleElement } from './create-axis-title-element';
